import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/snapchat': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM417.5 346.9c2.2-5.3-0.9-9.8-4.9-10.8-46.3-7.6-67.1-55.1-68-57.1-0.1-0.1-0.1-0.2-0.2-0.3-2.4-5-3-9.2-1.6-12.5 2.6-6.3 12.5-9.4 19-11.5 1.8-0.6 3.5-1.1 4.9-1.7 11.5-4.5 17.3-10.1 17.2-16.6-0.1-5.1-4.1-9.6-10.4-11.9-4-1.6-9.6-1.9-13.6 0-5.5 2.6-10.4 4-14.7 4.2-2.8-0.1-4.6-0.8-5.7-1.4 1.4-24 4.7-58-3.8-77.1-16.3-36.5-49.6-54.3-84.3-54.3-0.6 0-6.1 0.1-6.7 0.1-14 0-61.6 4-84.1 54.3-8.5 19.1-5.2 53.2-3.8 77.1-1.1 0.6-3.3 1.4-6.6 1.4-4.5 0-9.8-1.4-15.7-4.2-7.5-3.5-20.3 1.8-21.9 10.3-1 4.9 1.2 12.1 17 18.3 6.1 2.5 20.6 5.3 24 13.2 1.4 3.3 0.9 7.5-1.6 12.5-0.1 0.1-0.2 0.2-0.2 0.3-0.9 2-21.7 49.5-68 57.1-3.6 0.6-6.1 3.8-5.9 7.4 0.7 13.9 31.7 19.3 45.5 21.4 1.4 1.9 2.5 9.9 4.3 16 0.8 2.7 2.9 6 8.3 6s13.3-3.1 25.8-3.1c17.6 0 23.6 4 37.4 13.7 9.9 7 27.5 19.8 48.5 18.2 20.8 0.9 34.7-7.9 49.2-18.2 13.7-9.7 19.8-13.7 37.4-13.7 13 0 19.6 2.9 25.8 2.9h0.2c4.4 0 7-2.2 8.1-5.9 1.8-6.1 2.9-14 4.3-15.9 26.7-4.2 41.3-10.1 44.8-18.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/snapchat.js
// module id = 1024
// module chunks = 0